
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useToast } from '@/hooks/use-toast';
import { supabase } from '@/integrations/supabase/client';

const WhitelistSection = () => {
  const { toast } = useToast();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      toast({
        title: "Invalid email",
        description: "Please enter a valid email address",
        variant: "destructive",
      });
      return;
    }

    setLoading(true);
    
    try {
      // Call the Edge Function to add the email to the beta list
      const { data, error } = await supabase.functions.invoke("whitelist-signup", {
        body: { email },
      });
      
      if (error) {
        throw new Error(error.message);
      }
      
      toast({
        title: "Success!",
        description: data.message || "You've been added to our beta list. We'll notify you when we launch!",
      });
      
      setEmail('');
    } catch (error) {
      console.error("Beta signup error:", error);
      toast({
        title: "Let's fix this together",
        description: "We couldn't add you to the beta list. Please try again later.",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="whitelist-section" className="py-16 bg-sky">
      <div className="container mx-auto px-6 max-w-lg text-center">
        <h2 className="text-2xl font-semibold mb-4">Join Our Beta</h2>
        <p className="text-muted-foreground mb-8">
          We're currently in private beta. Join our beta list to get early access when we launch!
        </p>
        
        <form onSubmit={handleSubmit} className="flex flex-col md:flex-row gap-4">
          <Input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="flex-grow rounded-xl"
            required
          />
          <Button 
            type="submit" 
            disabled={loading} 
            className="bg-brand text-white rounded-xl font-semibold"
          >
            {loading ? "Submitting..." : "Join the Beta"}
          </Button>
        </form>
      </div>
    </section>
  );
};

export default WhitelistSection;
